import { forwardRef } from 'react';
import { v4 as uuid } from 'uuid';

import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    const id1 = uuid();
    const id2 = uuid();

    return (
        <SvgIcon ref={ref} {...props}>
            <g clipPath={`url(#${id1})`}>
                <g clipPath={`url(#${id2})`}>
                    <rect width='24' height='24' rx='4' fill='#FFA400' />
                    <rect x='2.30615' y='1.38379' width='5.53505' height='19.3727' fill='#222126' />
                    <path
                        d='M19.733 6.38352C19.9034 6.55398 20 6.78409 20 7.02557V24.5455C20 25.0483 19.5938 25.4545 19.0909 25.4545H0.909091C0.40625 25.4545 0 25.0483 0 24.5455V0.909091C0 0.40625 0.40625 0 0.909091 0H12.9744C13.2159 0 13.4489 0.096591 13.6193 0.267045L19.733 6.38352ZM17.9034 7.44318L12.5568 2.09659V7.44318H17.9034ZM3.86364 2.04545V3.86364H5.68182V2.04545H3.86364ZM5.68182 3.86364V5.68182H7.5V3.86364H5.68182ZM3.86364 5.68182V7.5H5.68182V5.68182H3.86364ZM5.68182 7.5V9.31818H7.5V7.5H5.68182ZM3.86364 9.31818V11.1364H5.68182V9.31818H3.86364ZM5.68182 11.1364V12.9545H7.5V11.1364H5.68182ZM3.86364 12.9545V14.7727H5.68182V12.9545H3.86364ZM3.86364 14.7727V19.3182H7.5V14.7727H3.86364ZM5.22727 16.1364H6.13636V17.9545H5.22727V16.1364Z'
                        fill='#FFA400'
                    />
                </g>
            </g>
            <defs>
                <clipPath id={id1}>
                    <rect width='24' height='24' fill='white' />
                </clipPath>
                <clipPath id={id2}>
                    <rect width='24' height='24' rx='4' fill='white' />
                </clipPath>
            </defs>
        </SvgIcon>
    );
});
